import { CopyInputField } from "../../../../../common/components/forms/inputs/InputField/CopyInputField";
import { DefaultInputField } from "../../../../../common/components/forms/inputs/InputField/DefaultInputField";
import styles from "../UserAdministrationUser.module.scss";

export const userAdministrationUserConfirmMessages = () => {
  const markAsUnreliableConfirmMessage = (
    <div className={styles.confirm}>
      <p className={styles.confirm_first_p}>
        Сигурни ли сте, че искате да маркирате този потребител като
        <strong> НЕРЕДОВЕН</strong>?
      </p>

      <p>След като бъде маркиран като нередовен:</p>
      <ul>
        <li>
          При опит за добавяне към събитие ще се показва обозначение{" "}
          <strong>„НЕРЕДОВЕН“</strong>
        </li>
        <li>Няма да може да прави резервации през клиентския портал</li>
        <li>
          Потребителят <strong>няма да вижда</strong> никъде, че е маркиран като
          нередовен
        </li>
        <li>
          В администраторската част статусът ще бъде ясно отбелязан навсякъде,
          където е необходимо
        </li>
      </ul>

      <p>
        <strong>
          Можете по всяко време да го отбележете отново като редовен.
        </strong>
      </p>
    </div>
  );

  return {
    markAsUnreliableConfirmMessage,
  };
};
